<div class="flex flex-col flex-auto min-w-0">
    <div class="flex-auto p-2 sm:p-10">
        <div class="content">
            <div class="mb-10">
                <h2  class="headers text-3xl font-semibold tracking-tight leading-8 flex-auto mb-2"
                    >
                    {{'MONTHLY_IMPORTER.TITLE'  | translate }}
                </h2>
                <h3  class="headers text-2xl font-semibold tracking-tight leading-8 flex-auto"
                    >
                    {{'MONTHLY_IMPORTER.PERFORMANCE_SUMMARY'  | translate }}
                </h3>
            </div> 
            <div class="form-group flex flex-wrap items-center mb-0">
                <mat-form-field appearance="fill">
                    <mat-label i18n="Inventories report date range label">{{
                        "INVENTORIES_REPORT_COMPONENT.CHART.DATE_RANGE" | translate
                        }}</mat-label>
                    <mat-date-range-input [rangePicker]="picker">
                        <input matStartDate placeholder="Start date" [formControl]="startDate" />
                        <input matEndDate placeholder="End date" [formControl]="endDate"
                            (dateChange)="changeEndDate($event)" />
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
            </div>



            <div>
                <div class="h-full aldiImporterTable">
                    <table mat-table [dataSource]="aldiImporterDataList" #aldiImporterMatSort="matSort" matSort>

                        <ng-container matColumnDef="vendor_name">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header >Vendor Name</th>
                                <td class="vendor_name" mat-cell *matCellDef="let formula">
                                    {{formula.importer_name}}
                                </td>
                            </ng-container>
                        <ng-container matColumnDef="nr_wpu_connected">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Number WPU Connected</th>
                                <td mat-cell *matCellDef="let formula">
                                    {{formula.supplier_count}}
                                </td>
                            </ng-container>
                        <ng-container matColumnDef="number_wpu_below80">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Number of WPU Below 80%</th>
                                <td mat-cell *matCellDef="let formula">
                                    {{formula.low_medium_compliance_supplier_count}}
                                </td>
                            </ng-container>
                        <ng-container matColumnDef="percentageBelow80">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>% of WPU Below 80%</th>
                                <td mat-cell *matCellDef="let formula">
                                    {{formula.percentage | number: "1.2-2"}}%
                                </td>
                            </ng-container>


                        <tr mat-header-row *matHeaderRowDef="aldiImporterData; sticky: true;"></tr>
                        <tr mat-row *matRowDef="let row; columns: aldiImporterData;" (click)="onRowClicked(row)" class="clickable-row"></tr>

                    </table>
                    <div *ngIf="hasNotData" style="text-align:center;">
                    No data is available
                    </div>
                    <loading-spinner *ngIf="isLoadingAldiImporterData"></loading-spinner>                       
                </div>
                <mat-paginator #aldiImporterPaginator="matPaginator" sticky [pageSizeOptions]="pageSizeOptions"
                showFirstLastButtons></mat-paginator>
            </div>
        </div>
    </div>
</div>
